/**
 * Variant savings: shows price and savings for options like "Pack de 2" and "caja de 12"
 * relative to the single-unit price ("Unidades").
 * Does not modify the template; detects variant names from Shopify and injects text via JS.
 */
(function() {
  'use strict';

  const PREFIX = window.KT_PREFIX || '';

  // Variant names for unit, pack of 2 and box of 12 (case/space insensitive)
  const PATTERNS = {
    unit: /unidades?$/i,
    pack2: /pack\s*de\s*2|pack\s*2/i,
    caja12: /caja\s*de\s*12|caja\s*12/i
  };

  function parseQuantity(optionValue) {
    if (!optionValue || typeof optionValue !== 'string') return 1;
    const v = optionValue.trim();
    /* Check pack/box before unit: "Pack de 2 unidades" and "Cajas (12 unidades)" end with "unidades" */
    if (PATTERNS.pack2.test(v)) return 2;
    if (PATTERNS.caja12.test(v)) return 12;
    if (PATTERNS.unit.test(v)) return 1;
    const num = v.match(/(\d+)/);
    return num ? parseInt(num[1], 10) : 1;
  }

  function isUnitVariant(optionValue) {
    if (!optionValue) return false;
    const v = String(optionValue).trim();
    if (!PATTERNS.unit.test(v)) return false;
    /* Must not be "Pack de 2 unidades" or "Cajas (12 unidades)" */
    if (PATTERNS.pack2.test(v) || PATTERNS.caja12.test(v)) return false;
    return true;
  }

  function isPackOrCaja(optionValue) {
    if (!optionValue) return false;
    const v = String(optionValue).trim();
    return PATTERNS.pack2.test(v) || PATTERNS.caja12.test(v);
  }

  /** Format price in cents to "X,XX€" */
  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '0,00€';
    const value = (Number(cents) / 100).toFixed(2);
    const formatted = value.replace('.', ',');
    return `${formatted}€`;
  }

  function getOptionValue(variant) {
    return (variant.option1 || variant.option2 || variant.option3 || '').trim();
  }

  function initProductVariants(container) {
    if (container.hasAttribute('data-variant-savings-inited')) return;

    const productUrl = container.dataset.url;
    if (!productUrl || !productUrl.includes('/products/')) return;

    const jsonUrl = productUrl.replace(/\/?$/, '') + '.js';
    fetch(jsonUrl)
      .then(function(res) { return res.json(); })
      .then(function(product) {
        if (!product || !product.variants || !product.variants.length) return;

        const variants = product.variants;
        let unitPriceCents = null;

        for (let i = 0; i < variants.length; i++) {
          const v = variants[i];
          const optionValue = getOptionValue(v);
          if (isUnitVariant(optionValue)) {
            unitPriceCents = v.price;
            break;
          }
        }

        if (unitPriceCents == null && variants.length > 0) {
          unitPriceCents = variants[0].price;
        }

        const variantMap = {};
        variants.forEach(function(v) {
          variantMap[v.id] = v;
        });

        container.querySelectorAll('[data-variant-id][data-option-value-id]').forEach(function(elm) {
          const variantId = elm.dataset.variantId;
          const variant = variantMap[variantId];
          if (!variant) return;

          const optionValue = getOptionValue(variant);
          const priceCents = variant.price;
          const quantity = parseQuantity(optionValue);
          const priceText = formatMoney(priceCents);

          let savingCents = 0;
          if (quantity > 1 && unitPriceCents != null) {
            const priceIfBoughtSingles = unitPriceCents * quantity;
            savingCents = priceIfBoughtSingles - priceCents;
          }

          let extraPlain = '';
          if (quantity === 1) {
            extraPlain = ' (' + priceText + ')';
          } else if (savingCents > 0) {
            extraPlain = ' (' + priceText + ', ahorra ' + formatMoney(savingCents) + ')';
          } else {
            extraPlain = ' (' + priceText + ')';
          }

          var labelEl;
          if (elm.tagName === 'OPTION') {
            const baseText = (elm.textContent || '').replace(/\s*\(\d+[\.,]\d+€.*\)\s*$/, '').trim();
            elm.textContent = baseText + extraPlain;
          } else {
            labelEl = elm.closest('.' + PREFIX + 'product-variant__item')?.querySelector('.' + PREFIX + 'product-variant__label');
            if (labelEl) {
              labelEl.querySelectorAll('.variant-savings-text').forEach(function(s) { s.remove(); });
              var wrapper = document.createElement('span');
              wrapper.className = 'variant-savings-text';
              wrapper.setAttribute('aria-hidden', 'true');
              requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                  wrapper.classList.add('variant-savings-visible');
                });
              });
              var priceSpan = document.createElement('span');
              priceSpan.className = 'variant-savings-price';
              priceSpan.textContent = priceText;
              if (savingCents > 0) {
                var saveSpan = document.createElement('span');
                saveSpan.className = 'variant-savings-amount';
                saveSpan.textContent = 'Ahorra ' + formatMoney(savingCents);
                wrapper.appendChild(priceSpan);
                wrapper.appendChild(document.createTextNode(' · '));
                wrapper.appendChild(saveSpan);
              } else {
                wrapper.appendChild(priceSpan);
              }
              labelEl.appendChild(wrapper);
            }
          }
        });

        container.setAttribute('data-variant-savings-inited', 'true');
      })
      .catch(function() {});
  }

  function run() {
    document.querySelectorAll('product-variants[data-url][data-has-variants]').forEach(initProductVariants);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('VARIANT_CHANGE', function() {
    document.querySelectorAll('product-variants[data-url][data-has-variants]').forEach(function(container) {
      container.removeAttribute('data-variant-savings-inited');
      initProductVariants(container);
    });
  });
})();
